export default __webpack_public_path__ + "static/media/unionKlein.0b8f55f6.jpg";